import { LoadingComponent } from "@components/atoms/Loading";
import { useTranslation } from "@refinedev/core";
import { debounce } from "lodash-es";
import { HTMLAttributes, ReactEventHandler, useCallback, useEffect, useMemo, useRef, useState } from "react";

const proxyURL = 'https://forms.epi3.co'
export interface GoogleFormProps {
}

export enum GoogleFormStatus {
    init,
    form,
    end,
    error,
}

const JS_PATH = 'iframeInitialScript.js'

const iframeInitialScriptLocation = () => {
    const { protocol, hostname, port } = window.location;
    return `${protocol}//${hostname}:${port}/${JS_PATH}`;
}

export const useGoogleForm = () => {
    const [status, setStatus] = useState(GoogleFormStatus.init);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.onmessage = (event) => {
            // logger.debug("onmessage event", event);
            if (event.origin == proxyURL) {
                if (Array.isArray(event.data)) {
                    // logger.debug('Parent received successfully.', event.data);
                    if (event.data.includes("Submit") || event.data.includes("Enviar")) { // Dejar esta
                        //if (event.data.includes("Next")) { // Esta es fake
                        // Enviar post api hasura
                        setStatus(GoogleFormStatus.end);
                    }
                } else if (event.data.message == 'script-loaded') {
                    // setTimeout(() => {
                    setLoading(false);
                    setStatus(GoogleFormStatus.form)
                    // }, 2000)
                } else if (event.data.message == 'form-not-found') {
                    setLoading(false);
                    setStatus(GoogleFormStatus.error)
                } else if (event.data.message == 'error') {
                    console.error('error', event)
                    setLoading(false);
                    setStatus(GoogleFormStatus.error)
                }
            }
        }
    }, [])

    return {
        loading,
        status,
    }
}

export interface GoogleFormComponentProps extends HTMLAttributes<HTMLDivElement> {
    loading: boolean,
    googleFormID: string
    status: GoogleFormStatus
}

export const GoogleFormComponent = ({ className, loading, status, googleFormID, ...rest }: GoogleFormComponentProps) => {
    const { translate } = useTranslation()
    const iframeRef = useRef<HTMLIFrameElement>(null)
    const iframeURL = `${proxyURL}/forms/d/e/${googleFormID}/viewform?embedded=true`
    const [delayLoading, setDelayLoading] = useState(false)

    const onLoadFrame = () => {
        // logger.debug("onLoadFrame");
        const frame = iframeRef.current
        if (!frame) return
        // logger.debug(frame)
        const iframeWindow = frame.contentWindow!;
        const message = iframeInitialScriptLocation();
        const targetOrigin = iframeURL;
        iframeWindow.postMessage(message, targetOrigin);
    }

    const f = useMemo(() => debounce((value) => setDelayLoading(value), 5000), [])
    useEffect(() => {
        if (loading) {
            f(true)
        } else {
            f.cancel()
            setDelayLoading(false)
        }
    }, [loading])

    return <div className={`flex items-center justify-center ${className}`} {...rest}>
        <div className='h-full w-full flex'>
            {status == GoogleFormStatus.error ? <h1 className={`absolute left-[50%] top-[50%] -translate-x-1/2 -translate-y-1/2 uppercase font-bold`}>
                Error
            </h1> : <>
                <iframe
                    ref={iframeRef}
                    onLoad={onLoadFrame}
                    className={`border-0 w-full h-full transition ease-in-out delay-1000 scrollbar-thin ${loading ? 'opacity-0' : 'opacity-100'} `}
                    src={iframeURL}
                >
                    {translate("common.loading")}
                </iframe>
                <div className="absolute left-[50%] top-[50%] -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
                    <LoadingComponent className={`transition-opacity duration-500 ${loading ? 'opacity-100' : 'opacity-0'}`} />
                    <span className={`mt-2 text-center transition-opacity duration-500 ${delayLoading ? 'opacity-100' : 'opacity-0'}`}>{translate("page.calendar.load-gform-error")}</span>
                </div>
            </>
            }
        </div>
    </div>
}